import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicy.css";

function PrivacyPolicyPage() {
  const navigate = useNavigate();
  const [lang, setLang] = useState("ko");

  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <div className="privacy-top-bar">
          <button className="privacy-back-button" onClick={() => navigate(-1)}>
            &larr; {lang === "ko" ? "뒤로가기" : "Back"}
          </button>
          <button
            className="privacy-lang-button"
            onClick={() => setLang(lang === "ko" ? "en" : "ko")}
          >
            {lang === "ko" ? "English" : "한국어"}
          </button>
        </div>

        {lang === "ko" ? <KoreanContent /> : <EnglishContent />}

        <div className="privacy-footer">
          <p>&copy; 2026 (주)터빈크루 (Turbinecrew Co., Ltd.). All rights reserved.</p>
        </div>
      </div>
    </div>
  );
}

function KoreanContent() {
  return (
    <>
      <h1 className="privacy-title">개인정보처리방침</h1>
      <p className="privacy-date">시행일: 2026년 3월 3일</p>

      <div className="privacy-content">
        <p>
          (주)터빈크루(이하 "회사")는 「개인정보 보호법」 제30조에 따라
          정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게
          처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을
          수립·공개합니다.
        </p>

        <section>
          <h2>제1조 (개인정보의 처리 목적)</h2>
          <p>
            회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
            개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용
            목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의
            동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <ol>
            <li>
              <strong>서비스 제공:</strong> TlatFarm 스마트농업 IoT 플랫폼
              서비스 제공, 드론 운용 관리, 스마트 폴 모니터링, 작물 분석 등
              서비스 이용에 따른 본인 식별·인증, 서비스 제공 및 유지·관리
            </li>
            <li>
              <strong>회원 관리:</strong> 서비스 이용에 따른 본인 확인,
              회원자격 유지·관리, 서비스 부정이용 방지, 각종 고지·통지
            </li>
            <li>
              <strong>서비스 개선:</strong> 서비스 이용 기록 분석을 통한
              서비스 개선 및 신규 서비스 개발
            </li>
          </ol>
        </section>

        <section>
          <h2>제2조 (개인정보의 처리 및 보유 기간)</h2>
          <p>
            회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터
            개인정보를 수집 시에 동의 받은 개인정보 보유·이용 기간 내에서
            개인정보를 처리·보유합니다.
          </p>
          <ol>
            <li>
              <strong>회원 정보:</strong> 계정 삭제 시까지. 단, 삭제 후에도
              관계 법령에 의하여 보존할 필요가 있는 경우 해당 법령에서 정한
              기간 동안 보존합니다.
            </li>
            <li>
              <strong>접속 기록(로그):</strong> 「통신비밀보호법」에 따라 3개월
            </li>
            <li>
              <strong>계정 삭제 후 데이터 보관:</strong> 계정 삭제(비활성화)
              후 일정 기간 내 데이터가 완전히 파기됩니다.
            </li>
          </ol>
        </section>

        <section>
          <h2>제3조 (처리하는 개인정보의 항목)</h2>
          <p>회사는 다음의 개인정보 항목을 처리하고 있습니다.</p>

          <h3>1. 필수 항목 (관리자에 의해 등록)</h3>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>항목</th>
                <th>수집 목적</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>아이디(사용자명)</td>
                <td>서비스 로그인 및 본인 식별</td>
              </tr>
              <tr>
                <td>비밀번호</td>
                <td>계정 보안 및 본인 인증</td>
              </tr>
              <tr>
                <td>이메일 주소</td>
                <td>본인 확인, 서비스 관련 고지·통지</td>
              </tr>
              <tr>
                <td>전화번호</td>
                <td>본인 확인, 긴급 연락</td>
              </tr>
              <tr>
                <td>닉네임</td>
                <td>서비스 내 표시명</td>
              </tr>
            </tbody>
          </table>
          <p>
            ※ 본 서비스의 계정은 관리자가 직접 등록하며, 등록 시 해당
            이용자에게 개인정보 수집·이용에 대한 사전 고지 및 동의를
            받습니다.
          </p>

          <h3>2. 서비스 이용 과정에서 자동으로 수집되는 항목</h3>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>항목</th>
                <th>수집 목적</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>IP 주소</td>
                <td>부정 접속 탐지 및 보안</td>
              </tr>
              <tr>
                <td>기기 식별자(Device ID)</td>
                <td>다중 기기 세션 관리</td>
              </tr>
              <tr>
                <td>브라우저 및 기기 정보(User-Agent)</td>
                <td>서비스 최적화 및 보안</td>
              </tr>
              <tr>
                <td>접속 일시</td>
                <td>서비스 이용 기록 관리</td>
              </tr>
              <tr>
                <td>쿠키(세션 토큰)</td>
                <td>로그인 상태 유지</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>제4조 (개인정보의 제3자 제공)</h2>
          <p>
            회사는 정보주체의 개인정보를 제1조에서 명시한 범위 내에서만
            처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보
            보호법」 제17조 및 제18조에 해당하는 경우에만 개인정보를
            제3자에게 제공합니다.
          </p>
        </section>

        <section>
          <h2>제5조 (개인정보 처리의 위탁)</h2>
          <p>
            회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보
            처리업무를 위탁하고 있습니다.
          </p>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>수탁업체</th>
                <th>위탁 업무 내용</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Google Cloud Platform (Google LLC)</td>
                <td>
                  클라우드 인프라 운영 (서버 호스팅, 데이터베이스, 메시징
                  서비스)
                </td>
              </tr>
              <tr>
                <td>Firebase (Google LLC)</td>
                <td>푸시 알림 서비스</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>제6조 (정보주체의 권리·의무 및 행사방법)</h2>
          <p>
            정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련
            권리를 행사할 수 있습니다.
          </p>
          <ol>
            <li>개인정보 열람 요구</li>
            <li>오류 등이 있을 경우 정정 요구</li>
            <li>삭제 요구</li>
            <li>처리정지 요구</li>
          </ol>
          <p>
            위 권리 행사는 회사에 대해
            이메일(contact@turbinecrew.co.kr)을 통하여 하실 수 있으며,
            회사는 이에 대해 지체 없이 조치하겠습니다.
          </p>
        </section>

        <section>
          <h2>제7조 (개인정보의 파기 절차 및 방법)</h2>
          <p>
            회사는 개인정보 보유 기간의 경과, 처리 목적 달성 등
            개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를
            파기합니다.
          </p>
          <ol>
            <li>
              <strong>파기 절차:</strong> 불필요한 개인정보는 개인정보의
              처리가 불필요한 것으로 인정되는 날로부터 5일 이내에 그
              개인정보를 파기합니다.
            </li>
            <li>
              <strong>파기 방법:</strong> 전자적 파일 형태의 정보는 기록을
              재생할 수 없는 기술적 방법을 사용합니다. 종이에 출력된
              개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
            </li>
          </ol>
        </section>

        <section>
          <h2>제8조 (개인정보의 안전성 확보 조치)</h2>
          <p>
            회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고
            있습니다.
          </p>
          <ol>
            <li>
              <strong>비밀번호 암호화:</strong> 비밀번호는 SHA-256 + salt 단방향
              암호화하여 저장·관리됩니다.
            </li>
            <li>
              <strong>전화번호 보호:</strong> 전화번호는 해시(SHA-256) 및
              암호화(AES)하여 이중 보호합니다.
            </li>
            <li>
              <strong>통신 암호화:</strong> 개인정보는 HTTPS(SSL/TLS)를
              통해 암호화하여 전송됩니다.
            </li>
            <li>
              <strong>접근 권한 관리:</strong> 개인정보에 대한 접근 권한을
              제한하고 관리합니다.
            </li>
            <li>
              <strong>세션 보안:</strong> 인증 토큰은 HttpOnly 쿠키로
              관리되며, 토큰은 해시하여 저장합니다.
            </li>
          </ol>
        </section>

        <section>
          <h2>제9조 (쿠키의 사용)</h2>
          <p>
            회사는 서비스 이용 과정에서 다음과 같은 쿠키를 사용합니다.
          </p>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>쿠키명</th>
                <th>용도</th>
                <th>유효 기간</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>refresh_token</td>
                <td>로그인 세션 유지</td>
                <td>30일</td>
              </tr>
            </tbody>
          </table>
          <p>
            회사는 광고 또는 추적 목적의 쿠키를 사용하지 않습니다.
            사용되는 쿠키는 모두 서비스 운영에 필수적인 기능성
            쿠키입니다.
          </p>
        </section>

        <section>
          <h2>제10조 (개인정보 보호책임자)</h2>
          <p>
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고,
            개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을
            위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <div className="privacy-info-box">
            <p>
              <strong>개인정보 보호책임자</strong>
            </p>
            <p>성명: 전기은</p>
            <p>직위: 대표이사</p>
            <p>연락처: contact@turbinecrew.co.kr</p>
          </div>
          <p>
            정보주체께서는 회사의 서비스를 이용하시면서 발생한 모든
            개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
            개인정보 보호책임자에게 문의하실 수 있습니다. 회사는
            정보주체의 문의에 대해 지체 없이 답변 및 처리해드리겠습니다.
          </p>
        </section>

        <section>
          <h2>제11조 (권익침해 구제방법)</h2>
          <p>
            정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보
            분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에
            분쟁해결이나 상담 등을 신청할 수 있습니다.
          </p>
          <ul>
            <li>
              개인정보분쟁조정위원회: (국번없이) 1833-6972 (
              <a href="https://www.kopico.go.kr" target="_blank" rel="noopener noreferrer">
                www.kopico.go.kr
              </a>
              )
            </li>
            <li>
              개인정보침해신고센터: (국번없이) 118 (
              <a href="https://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">
                privacy.kisa.or.kr
              </a>
              )
            </li>
            <li>
              대검찰청: (국번없이) 1301 (
              <a href="https://www.spo.go.kr" target="_blank" rel="noopener noreferrer">
                www.spo.go.kr
              </a>
              )
            </li>
            <li>
              경찰청: (국번없이) 182 (
              <a href="https://ecrm.cyber.go.kr" target="_blank" rel="noopener noreferrer">
                ecrm.cyber.go.kr
              </a>
              )
            </li>
          </ul>
        </section>

        <section>
          <h2>제12조 (개인정보 처리방침 변경)</h2>
          <p>
            이 개인정보처리방침은 2026년 3월 3일부터 적용됩니다. 이전의
            개인정보 처리방침은 아래에서 확인하실 수 있습니다.
          </p>
          <p>- 이전 버전: 없음 (최초 시행)</p>
        </section>
      </div>
    </>
  );
}

function EnglishContent() {
  return (
    <>
      <h1 className="privacy-title">Privacy Policy</h1>
      <p className="privacy-date">Effective Date: March 3, 2026</p>

      <div className="privacy-content">
        <p>
          Turbinecrew Co., Ltd. (hereinafter "the Company") establishes and
          discloses the following Privacy Policy in accordance with Article 30
          of the Personal Information Protection Act of the Republic of Korea,
          to protect the personal information of data subjects and to handle
          related grievances promptly and smoothly.
        </p>

        <section>
          <h2>Article 1 (Purpose of Processing Personal Information)</h2>
          <p>
            The Company processes personal information for the following
            purposes. Personal information being processed shall not be used
            for purposes other than those stated below, and if the purpose of
            use changes, necessary measures such as obtaining separate consent
            will be taken in accordance with Article 18 of the Personal
            Information Protection Act.
          </p>
          <ol>
            <li>
              <strong>Service Provision:</strong> Providing the TlatFarm Smart
              Agriculture IoT platform service, including drone operation
              management, smart pole monitoring, crop analysis, user
              identification and authentication, and service maintenance.
            </li>
            <li>
              <strong>User Management:</strong> Identity verification for
              service use, maintaining user eligibility, preventing
              unauthorized use, and delivering notices and notifications.
            </li>
            <li>
              <strong>Service Improvement:</strong> Analyzing service usage
              records to improve services and develop new features.
            </li>
          </ol>
        </section>

        <section>
          <h2>Article 2 (Retention Period of Personal Information)</h2>
          <p>
            The Company processes and retains personal information within the
            retention and use period prescribed by law or within the period
            agreed upon at the time of collection.
          </p>
          <ol>
            <li>
              <strong>User Information:</strong> Until account deletion.
              However, if retention is required by relevant laws, the
              information will be retained for the period specified by such
              laws.
            </li>
            <li>
              <strong>Access Logs:</strong> 3 months in accordance with the
              Protection of Communications Secrets Act.
            </li>
            <li>
              <strong>Post-Deletion Data Retention:</strong> After account
              deactivation, data is completely destroyed within a set period.
            </li>
          </ol>
        </section>

        <section>
          <h2>Article 3 (Categories of Personal Information Processed)</h2>
          <p>
            The Company processes the following categories of personal
            information.
          </p>

          <h3>1. Required Items (Registered by Administrator)</h3>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Username</td>
                <td>Service login and identification</td>
              </tr>
              <tr>
                <td>Password</td>
                <td>Account security and authentication</td>
              </tr>
              <tr>
                <td>Email Address</td>
                <td>Identity verification, service notifications</td>
              </tr>
              <tr>
                <td>Phone Number</td>
                <td>Identity verification, emergency contact</td>
              </tr>
              <tr>
                <td>Nickname</td>
                <td>Display name within the service</td>
              </tr>
            </tbody>
          </table>
          <p>
            ※ Accounts are registered by an administrator. Upon registration,
            the user is informed of and consents to the collection and use of
            their personal information.
          </p>

          <h3>2. Automatically Collected Items</h3>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>IP Address</td>
                <td>Unauthorized access detection and security</td>
              </tr>
              <tr>
                <td>Device Identifier (Device ID)</td>
                <td>Multi-device session management</td>
              </tr>
              <tr>
                <td>Browser and Device Information (User-Agent)</td>
                <td>Service optimization and security</td>
              </tr>
              <tr>
                <td>Access Date and Time</td>
                <td>Service usage record management</td>
              </tr>
              <tr>
                <td>Cookies (Session Tokens)</td>
                <td>Maintaining login session</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>Article 4 (Provision of Personal Information to Third Parties)</h2>
          <p>
            The Company processes personal information only within the scope
            specified in Article 1 and provides personal information to third
            parties only when it falls under Articles 17 and 18 of the
            Personal Information Protection Act, such as with the consent of
            the data subject or special provisions of law.
          </p>
        </section>

        <section>
          <h2>Article 5 (Entrustment of Personal Information Processing)</h2>
          <p>
            The Company entrusts the following personal information processing
            tasks for smooth service provision.
          </p>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>Entrusted Party</th>
                <th>Entrusted Tasks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Google Cloud Platform (Google LLC)</td>
                <td>
                  Cloud infrastructure operation (server hosting, database,
                  messaging services)
                </td>
              </tr>
              <tr>
                <td>Firebase (Google LLC)</td>
                <td>Push notification service</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>Article 6 (Rights of Data Subjects and How to Exercise Them)</h2>
          <p>
            Data subjects may exercise the following rights regarding personal
            information protection at any time.
          </p>
          <ol>
            <li>Request to access personal information</li>
            <li>Request for correction of errors</li>
            <li>Request for deletion</li>
            <li>Request to suspend processing</li>
          </ol>
          <p>
            The above rights may be exercised by contacting the Company via
            email (contact@turbinecrew.co.kr), and the Company will take
            action without delay.
          </p>
        </section>

        <section>
          <h2>Article 7 (Destruction of Personal Information)</h2>
          <p>
            The Company destroys personal information without delay when it
            becomes unnecessary due to expiration of the retention period,
            achievement of the processing purpose, or other reasons.
          </p>
          <ol>
            <li>
              <strong>Destruction Procedure:</strong> Unnecessary personal
              information is destroyed within 5 days from the date it is
              deemed no longer necessary.
            </li>
            <li>
              <strong>Destruction Method:</strong> Electronic files are
              destroyed using technical methods that prevent recovery.
              Printed personal information is destroyed by shredding or
              incineration.
            </li>
          </ol>
        </section>

        <section>
          <h2>Article 8 (Measures to Ensure Security of Personal Information)</h2>
          <p>
            The Company takes the following measures to ensure the security of
            personal information.
          </p>
          <ol>
            <li>
              <strong>Password Encryption:</strong> Passwords are stored and
              managed using SHA-256 + salt one-way encryption.
            </li>
            <li>
              <strong>Phone Number Protection:</strong> Phone numbers are
              protected with both hashing (SHA-256) and encryption (AES).
            </li>
            <li>
              <strong>Communication Encryption:</strong> Personal information
              is transmitted encrypted via HTTPS (SSL/TLS).
            </li>
            <li>
              <strong>Access Control:</strong> Access to personal information
              is restricted and managed.
            </li>
            <li>
              <strong>Session Security:</strong> Authentication tokens are
              managed via HttpOnly cookies and stored as hashes.
            </li>
          </ol>
        </section>

        <section>
          <h2>Article 9 (Use of Cookies)</h2>
          <p>
            The Company uses the following cookies during service operation.
          </p>
          <table className="privacy-table">
            <thead>
              <tr>
                <th>Cookie Name</th>
                <th>Purpose</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>refresh_token</td>
                <td>Maintaining login session</td>
                <td>30 days</td>
              </tr>
            </tbody>
          </table>
          <p>
            The Company does not use cookies for advertising or tracking
            purposes. All cookies used are essential functional cookies for
            service operation.
          </p>
        </section>

        <section>
          <h2>Article 10 (Privacy Officer)</h2>
          <p>
            The Company has designated the following Privacy Officer to
            oversee all personal information processing and to handle
            complaints and remedies related to personal information
            protection.
          </p>
          <div className="privacy-info-box">
            <p>
              <strong>Privacy Officer</strong>
            </p>
            <p>Name: Kieun Jeon</p>
            <p>Title: CEO</p>
            <p>Contact: contact@turbinecrew.co.kr</p>
          </div>
          <p>
            Data subjects may direct all inquiries, complaints, and requests
            for remedy related to personal information protection to the
            Privacy Officer. The Company will respond to and process such
            inquiries without delay.
          </p>
        </section>

        <section>
          <h2>Article 11 (Remedies for Infringement of Rights)</h2>
          <p>
            Data subjects may apply for dispute resolution or consultation to
            the following organizations for remedy of personal information
            infringement.
          </p>
          <ul>
            <li>
              Personal Information Dispute Mediation Committee: 1833-6972 (
              <a href="https://www.kopico.go.kr" target="_blank" rel="noopener noreferrer">
                www.kopico.go.kr
              </a>
              )
            </li>
            <li>
              KISA Privacy Center: 118 (
              <a href="https://privacy.kisa.or.kr" target="_blank" rel="noopener noreferrer">
                privacy.kisa.or.kr
              </a>
              )
            </li>
            <li>
              Supreme Prosecutors' Office: 1301 (
              <a href="https://www.spo.go.kr" target="_blank" rel="noopener noreferrer">
                www.spo.go.kr
              </a>
              )
            </li>
            <li>
              National Police Agency: 182 (
              <a href="https://ecrm.cyber.go.kr" target="_blank" rel="noopener noreferrer">
                ecrm.cyber.go.kr
              </a>
              )
            </li>
          </ul>
        </section>

        <section>
          <h2>Article 12 (Changes to This Privacy Policy)</h2>
          <p>
            This Privacy Policy is effective as of March 3, 2026. Previous
            versions of this Privacy Policy can be found below.
          </p>
          <p>- Previous version: None (initial version)</p>
        </section>
      </div>
    </>
  );
}

export default PrivacyPolicyPage;
